@if (multiple()) {
  <p-multiSelect
    [inputId]="inputId()"
    [id]="inputId()"
    [name]="inputId()"
    class="novatiq-geographies-picker__control w-full"
    [style]="{ width: '100%' }"
    [options]="options()"
    optionLabel="countryName"
    optionValue="iso"
    [(ngModel)]="selectedIsos"
    [placeholder]="placeholderKey() | translate"
    [ariaLabel]="ariaLabelKey() | translate"
    [display]="displayFormat()"
    [showClear]="showClear()"
    [disabled]="isControlDisabled"
    [filter]="true"
    [filterBy]="'countryName,iso'"
    [filterPlaceHolder]="'search' | translate"
    [emptyFilterMessage]="'noResultsFound' | translate"
    [showToggleAll]="showToggleAll()"
    [appendTo]="appendTo()"
    [panelStyleClass]="panelClass"
    [optionDisabled]="useDisabledOptions() ? 'disabled' : undefined"
    (onChange)="onValueChange()"
    (onClear)="onValueChange()"
    (onBlur)="onBlur()"
  >
    <ng-template #header>
      <div class="novatiq-geographies-picker__panel-title px-4 pt-4 pb-2 font-semibold text-color">
        {{ panelTitleKey() | translate }}
      </div>
    </ng-template>
    <ng-template #dropdownicon> <span class="pi pi-map" aria-hidden="true"></span> </ng-template>
    <ng-template #filtericon>
      <span class="pi pi-map-marker novatiq-geographies-picker__filter-end-icon" aria-hidden="true"></span>
    </ng-template>
    <ng-template #item let-opt>
      <span
        class="novatiq-geographies-picker__item-row flex items-center flex-1 min-w-0 gap-2"
        [pTooltip]="opt.disabled ? ('geography_already_used' | translate) : ''"
        tooltipPosition="right"
      >
        <span [class]="flagClass(opt.iso) + ' flex-shrink-0'" aria-hidden="true"></span>
        <span
          class="novatiq-geographies-picker__item-label whitespace-nowrap overflow-hidden text-ellipsis flex-1 min-w-0"
        >
          {{ countryLabel(opt) }}
        </span>
        @if (opt.disabled) {
          <i class="pi pi-lock text-surface-400 shrink-0" aria-hidden="true"></i>
        }
      </span>
    </ng-template>
  </p-multiSelect>
} @else {
  <p-select
    [inputId]="inputId()"
    [id]="inputId()"
    [name]="inputId()"
    class="novatiq-geographies-picker__control w-full"
    [style]="{ width: '100%' }"
    [options]="options()"
    optionLabel="countryName"
    optionValue="iso"
    [(ngModel)]="selectedIso"
    [placeholder]="placeholderKey() | translate"
    [ariaLabel]="ariaLabelKey() | translate"
    [disabled]="isControlDisabled"
    [filter]="true"
    [filterBy]="'countryName,iso'"
    [filterPlaceholder]="'search' | translate"
    [emptyFilterMessage]="'noResultsFound' | translate"
    [showClear]="showClear()"
    [appendTo]="appendTo()"
    [panelStyleClass]="panelClass"
    [optionDisabled]="useDisabledOptions() ? 'disabled' : undefined"
    (onChange)="onValueChange()"
    (onBlur)="onBlur()"
  >
    <ng-template #header>
      <div class="novatiq-geographies-picker__panel-title px-4 pt-4 pb-2 font-semibold text-color">
        {{ panelTitleKey() | translate }}
      </div>
    </ng-template>
    <ng-template #dropdownicon>
      <span class="novatiq-geographies-picker__dropdown-icons flex items-center gap-1" aria-hidden="true">
        <span class="pi pi-map"></span> <span class="pi pi-chevron-down"></span>
      </span>
    </ng-template>
    <ng-template #filtericon>
      <span class="pi pi-map-marker novatiq-geographies-picker__filter-end-icon" aria-hidden="true"></span>
    </ng-template>
    <ng-template #item let-opt>
      <span
        class="novatiq-geographies-picker__item-row flex items-center flex-1 min-w-0 gap-2"
        [pTooltip]="opt.disabled ? ('geography_already_used' | translate) : ''"
        tooltipPosition="right"
      >
        <span [class]="flagClass(opt.iso) + ' flex-shrink-0'" aria-hidden="true"></span>
        <span
          class="novatiq-geographies-picker__item-label whitespace-nowrap overflow-hidden text-ellipsis flex-1 min-w-0"
        >
          {{ countryLabel(opt) }}
        </span>
        @if (opt.disabled) {
          <i class="pi pi-lock text-surface-400 shrink-0" aria-hidden="true"></i>
        }
      </span>
    </ng-template>
    <ng-template #selectedItem let-item>
      <div class="flex items-center gap-2 min-w-0">
        <span [class]="flagClass(item.iso)" aria-hidden="true"></span> <span>{{ countryLabel(item) }}</span>
      </div>
    </ng-template>
  </p-select>
}
